import { render, staticRenderFns } from "./ServicosCadastro.vue?vue&type=template&id=9b841412&scoped=true&"
import script from "./ServicosCadastro.vue?vue&type=script&lang=js&"
export * from "./ServicosCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ServicosCadastro.vue?vue&type=style&index=0&id=9b841412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b841412",
  null
  
)

export default component.exports